import {
  ORGPLANS_FETCHING,
  ORGPLANS_SUCCESS,
  ORGPLANS_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ORGPLANS_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ORGPLANS_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ORGPLANS_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
